var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['form-section', { 'form-section--no-margin': _vm.noMargin }]},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onVisibilityChanged),expression:"onVisibilityChanged"}],staticClass:"section-visibility"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }